import { isNil } from 'lodash';
import { useCallback } from 'react';
import { getTitleComponentId } from '@shared/data/entity';
import { fieldFromComponentData } from '@shared/data/entity/fields/fieldFromComponentData';
import { useDefaultFields } from '@shared/scenes/entity/create/hooks/useDefaultFields';
import { useSaveNewEntity } from '@shared/scenes/entity/create/hooks/useSaveNewCardEntity';
import { useWorkflowTemplate } from '@shared/scenes/workflows/hooks';
import { API } from '@shared/types/api';

export function useCreateRelatedEntity({
  workflowTemplateId,
}: {
  workflowTemplateId?: string | null;
  disabled?: boolean;
}): (name: string) => Promise<API.WorkflowEntity | null> {
  const { saveEntity } = useSaveNewEntity(workflowTemplateId ?? undefined);
  const { workflowTemplate } = useWorkflowTemplate(workflowTemplateId);
  const defaultFields = useDefaultFields({ workflowTemplateId, isViewTemplateRequired: false });
  const titleComponentId = getTitleComponentId(workflowTemplate);
  const titleComponent = workflowTemplate?.components.find(c => c.id === titleComponentId);

  return useCallback(
    async (titleFieldData: any) => {
      const titleField = titleComponent && fieldFromComponentData(titleComponent, titleFieldData);
      if (isNil(titleComponent) || isNil(titleField)) {
        return null;
      }
      try {
        const result = await saveEntity({
          ...(defaultFields ?? {}),
          [titleComponent?.id]: titleField,
        });
        const newEntity = result?.data?.createWorkflowEntity?.entity;

        return newEntity ?? null;
      } catch {
        return null;
      }
    },
    [saveEntity, defaultFields, titleComponent],
  );
}
